/**
 * Splits a string into multiple items based on a selector pattern.
 * When the selector matches a line, it marks the start of a new item.
 *
 * @param text - The string to split (with line breaks)
 * @param selector - Either a regex pattern or a string to match against each line
 * @returns An array of strings, where each string is an item that starts when the selector matches
 * @deprecated move to coolcolduk/utils
 */
export default function splitStringMulti(text: string, selector: RegExp | string): string[] {
  const lines = text.split(/\r?\n/);
  const result: string[] = [];
  let currentItem: string[] = [];

  const isMatch: (s: string) => boolean =
    typeof selector === 'string' ? (s) => s.includes(selector) : (s) => selector.test(s);

  lines.forEach((line) => {
    if (isMatch(line) && currentItem.length > 0) {
      // Start a new item, save the previous one
      result.push(currentItem.join('\n'));
      currentItem = [line];
    } else {
      // Continue current item
      currentItem.push(line);
    }
  });

  // Add the last item if there's any content
  if (currentItem.length > 0) {
    result.push(currentItem.join('\n'));
  }

  return result;
}
